<template>
  <div class="header">
    <div class="container border" >
      <div style="width: 71%"></div>
      <img class="img_01" src="../assets/jicon-01.png">
      <a class="tel">Tel:18513110521</a>
    </div>
    <div class="displayF justifyContent padding15">
       <img src="../assets/1633588690377798.png">
      <div style="width: 100px">
      </div>
      <div style="height: 100%">
      <div class="displayF">
        <a href="/index">首页</a>
        <a href="/content">最强猎手</a>
        <a href="/service">服务项目</a>
        <a href="/industry">行业咨询</a>
        <a href="/about">联系我们</a>
        <a href="/login">登录/注册</a>
        <img src="../assets/search.png" style="width: 30px">
      </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background: #0c4270
}

.container {
  display: flex;
  padding: 10px 20px;
  text-align: center;
  align-items: center;
}
.displayF{
  display: flex;
  height: 100%;
  align-items: center;
  text-align: center;
}
.padding15 {
  padding: 5px;
}
.border{
  border-bottom: 1px solid #235c8c;
}


.img_01{
  max-height: 25px;
  margin-right: 5px;
}
.tel{
  color: #ef801a;
}
.displayF>a{
  color: #fff;
  padding: 0 35px;
  display: block;
  font-size: 16px;
  align-items: center;
  height: 50px;
  line-height: 50px;
  text-decoration: none;
}
.justifyContent {
  justify-content: center;
}
.displayF>a:hover {
  color: #fff;
  background: #ef801a
}
</style>
